<template>
  <div v-if="showBanner" class="notification-element">
    <div :class="[extraCardClasses, 'cancelled-contract-banner']" id="cancelledContractBanner">
      <div class="cancelled-contract" :class="{card: addCardClasses}">
        <div class="text" v-if="!contractState.contractTerminated">
          <dyn-slot :slot-data="dismissalSlotData"><slot name="txtContractDismissed"></slot></dyn-slot>
        </div>
        <button class="filled white"
          v-if="!contractState.contractTerminated && contractState.hasPendingDismissal"
          :disabled="loadingCancelDismissal"
          @click="cancelPendingDismissal()"
        ><slot name="lblButtonRevokeDismissal"></slot></button>
        <div class="text" v-if="contractState.contractTerminated">
          <slot name="txtContractTerminated"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapActions } from 'vuex'

export default {
  name: 'CancelledTariffBanner',
  data () {
    return {
      currentCustomer: {
        contract: {
          state: ''
        }
      },
      loadedCurrentCustomer: false,
      loading: false,
      contractCancelled: false,
      loadingCancelDismissal: false,
      cancellactionRevoked: false
    }
  },
  watch: {
    showBanner: {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:showBanner', newValue)
      }
    }
  },
  methods: {
    ...mapActions('contract', [
      'loadContractState'
    ]),
    async cancelPendingDismissal () {
      const comp = this

      this.startLoader()
      comp.loadingCancelDismissal = true

      comp.$apollo
        .mutate({
          mutation: gql`
      mutation deleteContractDismissal {
        deleteContractDismissal {
          success
        }
      }
    `
        })
        .then(async (data) => {
          comp.successToast(comp.successMessage)
          comp.cancellactionRevoked = true
          await this.loadContractState({ forceUpdate: true })
        })
        .catch((error) => {
          console.error('Error deleting contract dismissal:', error)
        })
        .finally(() => {
          comp.loadingCancelDismissal = false
          this.stopLoader()
        })
    }
  },
  computed: {
    successMessage: function () {
      return this.getSlotText('txtToastSuccess', 'Kündigung aufgehoben')
    },
    dismissalSlotData: function () {
      return {
        formattedDismissalDate: this.contractState.formattedDismissalDate
      }
    },
    bShowOnlyWhenTerminated: function () {
      return JSON.parse(this.showOnlyWhenTerminated)
    },
    showBanner: function () {
      if (this.cancellactionRevoked) {
        return false
      }
      if (this.contractState.contractTerminated) {
        return true
      }
      if (this.contractState.hasPendingDismissal) {
        return true
      }
      return this.contractState.contractCancelled && !this.bShowOnlyWhenTerminated
    },
    addCardClasses: function () {
      return this.addCardClass
    },
    extraCardClasses: function () {
      if (this.addCardClass) {
        return 'card-wrapper notification-card'
      }
      return ''
    }
  },
  props: {
    showOnlyWhenTerminated: {
      type: String,
      default: 'false'
    },
    fromWrapper: {
      type: Boolean,
      default: false
    },
    addCardClass: {
      type: Boolean,
      default: false
    },
    contractState: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [

  ]
}
</script>
